import { VerticalSpacing } from "../VerticalSpacing"
import { RightAlignPanel } from "../ReusableStyledComponents/RightAlignPanel";
import { V3Button } from "../Button";
import { V3ButtonColor } from "../Button/V3Button.types";
import { V3CaptionGrey35 } from "../ReusableStyledComponents/V3CaptionGrey35";
import { useRef } from "react";
import { AddContentUploadWrapper } from "./AddContentUpload.styles";
import { V3IconUpload } from "../Icons";
import { V3BodyGrey48 } from "../ReusableStyledComponents/V3BodyGrey48";
import { LearnMoreCTA } from "../ReusableStyledComponents/LearnMoreCTA";

// type AddWebsiteURlFormik = {
//     url: string
// }

interface AddContentAddURLProps {
    onBackHandler: () => void,
    onFilesChoosen: (files: File[]) => void,
    onManualArticleSelect: () => void,
    onUrlSubmitted: (url: string) => void,
}

export const AddContentAddURL = ({ onBackHandler, onFilesChoosen, onManualArticleSelect }: AddContentAddURLProps) => {

    const inputFileRef = useRef<HTMLInputElement | null>(null);

    function handleFileSelected(selectorFiles: FileList): void {
        onFilesChoosen(Array.from(selectorFiles));
        if (inputFileRef && inputFileRef.current) inputFileRef.current.value = "";
    }

    // const formik = useFormik<AddWebsiteURlFormik>({
    //     initialValues: {
    //         url: '',
    //     },
    //     onSubmit: (values) => { onUrlSubmitted(values.url) },
    //     validationSchema: Yup.object().shape({
    //         url: Yup.string()
    //             .required("Please enter a url")
    //             .trim()
    //             .ensure()
    //             .matches(URL_REGEX, { message: "Please enter a valid URL", excludeEmptyString: true })
    //     })
    // });

    // const urlHasError = formik.errors.hasOwnProperty("url") && formik.touched.hasOwnProperty("url");
    // let urlError = urlHasError ? formik.errors.url : undefined;

    return <>
        {/* <form onSubmit={formik.handleSubmit} action="."> */}
        <VerticalSpacing bottom={24}>
            <VerticalSpacing bottom={12}>
                <V3CaptionGrey35>Add webpages to your portfolio: Upload a screenshot of the webpage you'd like to add below.</V3CaptionGrey35>
            </VerticalSpacing>
            <VerticalSpacing bottom={24}>
                <V3CaptionGrey35>Note: If the webpage you want to import is an article, you can <LearnMoreCTA onClick={onManualArticleSelect} text="import it as an article" /> instead.</V3CaptionGrey35>
            </VerticalSpacing>
            <AddContentUploadWrapper
                onClick={() => inputFileRef && inputFileRef.current && inputFileRef.current.click()}
            >
                <div><V3IconUpload /></div>
                <V3BodyGrey48>Select files</V3BodyGrey48>
            </AddContentUploadWrapper>
            {/* <VerticalSpacing bottom={6}>
                <V3BodyGrey35><strong>Website URL</strong></V3BodyGrey35>
            </VerticalSpacing> */}
            <input style={{ display: "none" }} type="file" ref={inputFileRef} onChange={(e: React.ChangeEvent<HTMLInputElement>) => e.target.files && handleFileSelected(e.target.files)} accept={".png,.jpg"} multiple />
            {/* <V3TextInput
                disableIconHover
                name="url"
                inputMode="url"
                placeholder="e.g. zapier.com"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.url}
                error={urlError}
                autoFocus={false}
            /> */}
            {/* <VerticalSpacing top={32}>
                <V3BodyGrey35>Alternatively you can <InlineLink onClick={() => inputFileRef && inputFileRef.current && inputFileRef.current.click()}>upload a screenshot</InlineLink>.</V3BodyGrey35>
            </VerticalSpacing> */}
        </VerticalSpacing>
        <RightAlignPanel>
            <div>
                <V3Button
                    type="button"
                    text="Back"
                    color={V3ButtonColor.secondary}
                    onClick={(e) => {
                        e.preventDefault();
                        onBackHandler();
                    }}
                />
            </div>
            <div>
                <V3Button
                    text={"Continue"}
                    onClick={async () => { }}
                />
            </div>
        </RightAlignPanel>
        {/* </form> */}
    </>
}